/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgCostCenter = {
  header: 'Todos os centros de custo ({{count}})',

  code: 'Código',
  active: 'Estado',
  name: 'Nome',
  currency: 'Uniforme',
  unit: 'Unidadee dos pais',
  actions: '',

  sortBy: 'Classificar por',
  sort: {
    byName: 'Nome',
    byUnitName: 'Unidade',
    byCode: 'Código',
  },

  hint: "Todos os pedidos feitos por meio da conta de compras da sua organização são vinculados a um centro de custo para fins de rastreamento. Cada unidade pode ter vários centros de custo. Para limitar os gastos, os orçamentos são alocados aos centros de custo. Um comprador seleciona um centro de custo no checkout.",
  disable: {
    confirm: 'Desabilitar',
  },

  messages: {
    deactivateTitle: 'Desabilitar este centro de custo?',
    deactivate:
      'Os centros de custo não utilizados não podem ser usados para fazer novas ordens. Certifique-se de que sua unidade tenha pelo menos um centro de custo. Os pedidos existentes não são afetados.',
    confirmEnabled: 'Centro de custo {{ item.name }} ativado com sucesso',
    confirmInutilizard: 'Centro de custo {{ item.name }} desativado com êxito',
    update: 'Centro de custo {{ item.name }} atualizado com êxito',
    create: 'Centro de custo {{ item.name }} Criado com sucesso',
  },
  info: {
    disabledEdit: 'Ativar o centro de custo para permitir a edição.',
    disabledEnable:
      'A unidade deve ser ativada antes que esse centro de custo possa ser ativado.',
  },

  details: {
    title: 'Detalhes do centro de custo',
    subtitle: 'Centro de custo: {{ item.name }}',
  },

  edit: {
    title: 'Editar centro de custo',
    subtitle: 'Centro de custo: {{ item.name }}',
  },

  create: {
    title: 'Criar centro de custo',
    subtitle: '',
  },

  budget: {
    link: 'Orçamentos',
  },

  breadcrumbs: {
    list: 'Todos os centros de custo',
    details: '{{name}}',
    budgets: 'Orçamentos',
  },
};

export const orgCostCenterAssignedBudgets = {
  title: 'Orçamentos asignados',
  subtitle: 'Centro de custo: {{ item.name }}',
  assigned: 'Orçamento {{ item.name }} atribuído com êxito',
  unassigned: 'Orçamento {{ item.name }} não atribuído correctamente',
};

export const orgCostCenterBudgets = {
  title: 'Gerenciar orçamentos',
  subtitle: 'Centro de custo: {{ item.name }}',
  assigned: 'Orçamento {{ item.name }} atribuído com êxito',
  unassigned: 'Orçamento {{ item.name }} não atribuído correctamente',
};
